<template>
  <div style="padding-bottom: 50px; padding-top: 30px">
    <template-breadcrumb-header-action-element>
      <template #content>
        <b-row>
          <a
            v-if="pptStatus && (isIndicaUser || isPNUDADMIN)"
            :href="pptUrl"
            class="exportPPT"
            target="_blank"
            size="sm"
            variant="primary"
            ><img width="40" src="static/icons/PPT.svg"
          /></a>
          <div
            v-if="!pptStatus && (isIndicaUser || isPNUDADMIN)"
            style="filter: saturate(0)"
            class="exportPPT"
            target="_blank"
            size="sm"
            variant="primary"
            :title="$t('label_download_PPT')"
            @click="generatePtt()"
          >
            <img width="40" src="static/icons/PPT.svg" />
          </div>
          <a
            v-if="pdfStatus"
            class="exportPDF"
            :href="pdfUrl"
            target="_blank"
            size="sm"
            variant="primary"
            ><img width="40" src="/static/icons/PDF.svg"
          /></a>
          <div
            v-if="!pdfStatus"
            style="filter: saturate(0)"
            class="exportPDF"
            target="_blank"
            size="sm"
            variant="primary"
            :title="$t('label_download_PDF')"
            @click="generatePdf()"
          >
            <img width="40" src="/static/icons/PDF.svg" />
          </div>
        </b-row>
      </template>
    </template-breadcrumb-header-action-element>
    <b-container style="max-width: 1500px">
      <b-row style="margin-bottom: 10px">
        <b-col lg="9">
          <b-card
            :title="$t('label_violenceSurvey_indicator_ovi_nameAcronym')"
            style="height: 100%; minheight: '165px'"
          >
            <b-row>
              <b-col md="8">
                <p class="card-text">
                  {{ $t("label_violenceSurvey_indicator_ovi_description") }}
                </p>
              </b-col>
              <b-col>
                <div
                  v-if="generalIndex"
                  id="generalIndex"
                  class="general-index center-block"
                  :class="
                    generalIndex >= 60
                      ? generalIndex > 85
                        ? 'positive'
                        : 'intermediate'
                      : 'negative'
                  "
                >
                  {{
                    generalIndex | currency("", 0, { thousandsSeparator: "" })
                  }}%
                </div>
                <div
                  v-if="!generalIndex"
                  class="general-index center-block negative"
                >
                  0%
                </div>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
        <b-col>
          <card-conventions
            height="100%"
            :show-ideal="false"
            :show-company="false"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col xl="6" style="display: flex">
          <card-chart-gauge-organizational-violence
            v-if="indicators"
            :data="kemData"
            alias="kem"
            :calculated-height="minHeight"
            @minHeight="setMinHeight"
          />
        </b-col>
        <b-col xl="6" style="display: flex">
          <card-chart-gauge-organizational-violence
            v-if="indicators"
            :data="torData"
            alias="tor"
            :calculated-height="minHeight"
            @minHeight="setMinHeight"
          />
        </b-col>
      </b-row>
      <b-row>
        <b-col xl="6" style="display: flex">
          <card-chart-gauge-organizational-violence
            v-if="indicators"
            :data="kiaData"
            alias="kia"
            :calculated-height="minHeight"
            @minHeight="setMinHeight"
          />
        </b-col>
        <b-col xl="6" style="display: flex">
          <card-chart-gauge-organizational-violence
            v-if="indicators"
            :data="pvaData"
            alias="pva"
            :calculated-height="minHeight"
            @minHeight="setMinHeight"
          />
        </b-col>
      </b-row>
    </b-container>
    <b-modal v-model="openDialog">
      <div v-if="modalType === 'pdf'">
        <div v-if="!pdfStatus">
          <h5 style="margin-bottom: 20px">
            {{ $t("label_reports_generate_report_title") }}
          </h5>
          <div>{{ $t("label_reports_generate_report") }}</div>
        </div>
        <div v-if="pdfStatus">
          <h5 style="margin-bottom: 20px">PDF report</h5>
          <div>
            Your report is ready. Click
            <a :href="pdfUrl" target="_blank">here</a> to download it.
          </div>
        </div>
      </div>
      <div v-if="modalType === 'ppt'">
        <div v-if="!pptStatus">
          <h5 style="margin-bottom: 20px">
            {{ $t("label_reports_generate_report_title") }}
          </h5>
          <div>{{ $t("label_reports_generate_report") }}</div>
        </div>
        <div v-if="pptStatus">
          <h5 style="margin-bottom: 20px">Power Point report</h5>
          <div>
            Your report is ready. Click
            <a :href="pptUrl" target="_blank">here</a> to download it.
          </div>
        </div>
      </div>

      <div slot="modal-footer" class="w-100" style="text-align: right">
        <b-button variant="primary" @click="openDialog = false">
          Close
        </b-button>
      </div>
    </b-modal>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import CardChartGaugeOrganizationalViolence from "./cards/CardChartGaugeOrganizationalViolence";
import { createHelpers } from "vuex-map-fields";
import { axiosCall } from "../utils/axiosCall";
const { mapFields } = createHelpers({
  getterType: "getUserAccountField",
  mutationType: "updateUserAccountField",
});

export default {
  name: "ReportsOrganizationalViolence",
  components: { CardChartGaugeOrganizationalViolence },
  data: function () {
    return {
      minHeight: 0,
      indicators: null,
      generalIndex: 0,
      pptStatus: null,
      pdfStatus: null,
      pptUrl: null,
      pdfUrl: null,
      openDialog: false,
      kemData: {
        ranges: {
          negMin1: 0,
          negMax1: 29.9999,
          interMin1: 30,
          interMax1: 64.9999,
          posMin1: 65,
          posMax1: 100,
          interMin2: null,
          interMax2: null,
          negMin2: null,
          negMax2: null,
        },
        markers: [0],
        ideals: [100],
        acronym: "label_violenceSurvey_indicator_kem_acronym",
        description: "label_violenceSurvey_indicator_kem_description",
        title: "label_violenceSurvey_indicator_kem_nameAcronym",
      },
      torData: {
        ranges: {
          negMin1: 0,
          negMax1: 29.9999,
          interMin1: 30,
          interMax1: 64.9999,
          posMin1: 65,
          posMax1: 100,
          interMin2: null,
          interMax2: null,
          negMin2: null,
          negMax2: null,
        },
        markers: [0],
        ideals: [100],
        acronym: "label_violenceSurvey_indicator_tor_acronym",
        description: "label_violenceSurvey_indicator_tor_description",
        title: "label_violenceSurvey_indicator_tor_nameAcronym",
      },
      kiaData: {
        ranges: {
          negMin1: 0,
          negMax1: 29.9999,
          interMin1: 30,
          interMax1: 64.9999,
          posMin1: 65,
          posMax1: 100,
          interMin2: null,
          interMax2: null,
          negMin2: null,
          negMax2: null,
        },
        markers: [0],
        ideals: [100],
        acronym: "label_violenceSurvey_indicator_kia_acronym",
        description: "label_violenceSurvey_indicator_kia_description",
        title: "label_violenceSurvey_indicator_kia_nameAcronym",
      },
      pvaData: {
        ranges: {
          negMin1: 0,
          negMax1: 59.9999,
          interMin1: 60,
          interMax1: 83.9999,
          posMin1: 84,
          posMax1: 100,
          interMin2: null,
          interMax2: null,
          negMin2: null,
          negMax2: null,
        },
        markers: [0],
        ideals: [100],
        acronym: "label_violenceSurvey_indicator_pva_acronym",
        description: "label_violenceSurvey_indicator_pva_description",
        title: "label_violenceSurvey_indicator_pva_nameAcronym",
      },
    };
  },
  computed: {
    lang() {
      return this.$i18n.locale;
    },
    ...mapFields(["username"]),
    ...mapGetters([
      "getCurrentSnapshot",
      "isPNUDADMIN",
      "getBusiness",
      "getToken",
      "getCurrentAccountRoleId",
      "isIndicaUser"
    ]),
  },
  async created() {
    await this.$store.dispatch("SNAPSHOTS_GET");
    await this.$store.dispatch("BUSINESS_GET");
    await axiosCall({
      url: `ViolenceSurveys/organizationalViolenceReport/${this.getCurrentSnapshot.snapshotId}`,
      method: "GET",
    }).then((indicators) => {
      this.indicators = indicators.data;
      this.generalIndex = Math.round(indicators.data.ovi, 0);
      this.kemData.value = Math.round(indicators.data.kem, 0);
      this.torData.value = Math.round(indicators.data.tor, 0);
      this.kiaData.value = Math.round(indicators.data.kia, 0);
      this.pvaData.value = Math.round(indicators.data.pva, 0);
    });
    await this.checkViolenceExistence();
    this.checkAllViolenceFilesExist();
  },
  methods: {
    setMinHeight(minHeight) {
      if (this.minHeight < minHeight) {
        this.minHeight = minHeight;
      }
    },
    generatePtt: async function () {
      await axiosCall({
        url: `ReportGenerations/ppt/organizational-violence/${this.getToken}/${this.getBusiness.id}/${this.getCurrentSnapshot.snapshotId}/${this.getCurrentAccountRoleId}/${this.lang}`,
      });
      this.modalType = "ppt";
      this.openDialog = true;
    },
    generatePdf: async function () {
      await axiosCall({
        url: `ReportGenerations/pdf/organizational-violence/${this.getToken}/${this.getBusiness.id}/${this.getCurrentSnapshot.snapshotId}/${this.getCurrentAccountRoleId}/${this.lang}`,
      });
      this.modalType = "pdf";
      this.openDialog = true;
    },
    checkAllViolenceFilesExist() {
      setInterval(() => this.checkViolenceExistence(), 20000);
    },
    checkViolenceExistence: async function () {
      if (!this.pptStatus) {
        await axiosCall({
          url: `ReportGenerations/existsInAmazon/ppt/organizational-violence/${this.getToken}/${this.getBusiness.id}/${this.getCurrentSnapshot.snapshotId}/${this.getCurrentAccountRoleId}/${this.lang}?noSpinner=true`,
        }).then((response) => {
          this.pptStatus = response.data.url.exists;
          this.pptUrl = response.data.url.url;
          this.lastGenerationPpt = response.data.url.last;
        });
      }
      if (!this.pdfStatus) {
        await axiosCall({
          url: `ReportGenerations/existsInAmazon/pdf/organizational-violence/${this.getToken}/${this.getBusiness.id}/${this.getCurrentSnapshot.snapshotId}/${this.getCurrentAccountRoleId}/${this.lang}?noSpinner=true`,
        }).then((response) => {
          this.pdfStatus = response.data.url.exists;
          this.pdfUrl = response.data.url.url;
          this.lastGenerationPdf = response.data.url.last;
        });
      }
      if (this.pdfStatus && this.pptStatus) {
        clearInterval();
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.general-index {
  font-size: 3rem;
  border-radius: 20px;
  text-align: center;
  margin-right: 20px;
}

.col-8 {
  padding-right: 5px;
}

.col {
  padding-left: 5px;
}
</style>
